export default (to, from, next) => {

    const auth = window.$cookies.get('admin-jwt');
    console.log('guest', auth )
    if (auth && auth != 'undefined') {
    console.log('auth' )

        next({ name: 'admin/tenants' });
    } else {
    console.log('no-auth' )

        next();
    }
}